/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Session_DeleteInputs */

const en_session_delete = /** @type {(inputs: Session_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete cook session`)
};

const de_session_delete = /** @type {(inputs: Session_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kochsession löschen`)
};

/**
* | output |
* | --- |
* | "Delete cook session" |
*
* @param {Session_DeleteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const session_delete = /** @type {((inputs?: Session_DeleteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Session_DeleteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_session_delete(inputs)
	return en_session_delete(inputs)
});